import { ViewModel as model } from "./model";
import template from './template.html';
import './style.less';
import { registerComponent } from '@/utils/engine/register-component';
registerComponent('fc-nps-item', { model: model, template: template });
